import { useModal } from "../../context/modal_provider";
import { FORM_ACTIONS } from "../../enums/form_actions_enum";
import { useAddOwnerMutation } from "../../hooks/use_site";
import DialogForm from "../material_react_table/dialog_form";

export function useAddSiteOwnerDialog() {
  const { openDialogModal } = useModal();

  return (siteData) => {
    openDialogModal({
      dialogTabs: [
        {
          label: "Add Site Owner",
          component: <AddSiteOwnerDialog siteData={siteData} />,
        },
      ],
    });
  };
}

export function AddSiteOwnerDialog({ siteData }) {
  const { closeDialogModal } = useModal();
  const { mutate: addOwnerMutation, isPending } = useAddOwnerMutation({
    onSuccess: () => {
      closeDialogModal();
    },
  });

  return (
    <DialogForm
      dialogAction={FORM_ACTIONS.ADD_OWNERS}
      selectedRow={siteData}
      onClose={closeDialogModal}
      isPending={isPending}
      handleConfirm={(data, action, dialogData) =>
        addOwnerMutation({
          siteId: data["site_id"],
          partnerCompanyId: dialogData[FORM_ACTIONS.ADD_OWNERS.fnDataAccessKey],
          partnerCompanyName: dialogData[FORM_ACTIONS.ADD_OWNERS.fnDataLabelKey],
        })
      }
    />
  );
}
